<form [formGroup]="form">
  <div class="row">
    <label for="Especies">Especies Certificables</label>
    <ng-select [formControl]="especiesCertificable" (change)="onEspeciesChange($event)" labelForId="especies"
      [multiple]="true" [items]="especiesCertificables" [bindValue]="'value'">
    </ng-select>
    <mat-error *ngIf="!especiesCertificable.valid">
      Debe seleccionar al menos una especie
    </mat-error>
  </div>
  <div class="row">
    <p>Etapas empresa</p>
    <rpe-check-list-form #checkList (formStatusChanges)="onEtapasFormStatusChange($event)"
      (formValueChanges)="onEtapasFormChange($event)" [formInput]="checkboxListInput"></rpe-check-list-form>
  </div>
  <div class="row">
    <rpe-file-uploader [files]="acreditacionEmpresaFormInput.files" [maxFiles]="5" [control]="files"
      [acceptedFiles]="'pdf'" [required]="true" (onFileChange)="onFileChange($event)"
      (onMaxFiles)="onMaxFilesChange($event)"></rpe-file-uploader>
    <mat-error *ngIf="!files.valid">
      Debe subir al menos un archivo
    </mat-error>
  </div>
</form>
